import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface Props {
  search: string;
  onSearch: (val: string) => void;
  category: string;
  onCategory: (val: string) => void;
  categories: string[];
}

const McpToolFilters: React.FC<Props> = ({
  search, onSearch, category, onCategory, categories
}) => (
  <div className="flex gap-3 mb-4">
    <div className="relative flex-1 max-w-xs">
      <MagnifyingGlassIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
      <input
        type="text" placeholder="Search tools..."
        className="w-full pl-9 pr-3 py-2 border rounded-md text-sm"
        value={search} onChange={(e) => onSearch(e.target.value)}
      />
    </div>
    <select
      className="border rounded-md px-3 py-2 text-sm"
      value={category} onChange={(e) => onCategory(e.target.value)}
    >
      <option value="">All Categories</option>
      {categories.map((c) => <option key={c} value={c}>{c}</option>)}
    </select>
  </div>
);

export default McpToolFilters;
